import classNames from "classnames";
import type { FC } from "react";
import type { Pp2ViewModel } from "./pp2ViewModel";
import type { Pp2CopyFeedback } from "./shared/useCopyFeedback";
import { Pp2SideBlocks } from "./side/pp2SideBlocks";
import styles from "./pp2View.module.scss";

/**
 * The shell's side area (3.4): rendered only with side blocks. A single block spans the content
 * width at every breakpoint (owner feedback, Q8); more blocks go 2-up from tablet.
 */
export const Pp2SideArea: FC<{ vm: Pp2ViewModel; copy: Pp2CopyFeedback }> = ({ vm, copy }) =>
  vm.sideBlockCount > 0 ? (
    <div className={classNames(styles.side, vm.sideBlockCount === 1 && styles.single)} data-test-id="pp2-side">
      <Pp2SideBlocks vm={vm} copy={copy} />
    </div>
  ) : null;
